import React from 'react';
import type { FC } from 'react';
import { ListItem } from '@interstate/components/List';
import { Box } from '@interstate/components/Box';
import { CheckBox } from '@interstate/components/CheckBox';
import type { DisplayItemKey } from '../constants';
import { NumericInput } from '@interstate/components/NumericInput';

const key = 'conditionalDiscount';

type ConditionalDiscountProps = {
    isActive: boolean;
    value?: string;
    onDisplayActiveChange: (displayKey: DisplayItemKey, checked: boolean) => void;
    onDisplayValueChange: (displayKey: DisplayItemKey, newDisplayValue?: string) => void;
};
const ConditionalDiscount: FC<ConditionalDiscountProps> = ({ isActive, onDisplayActiveChange, onDisplayValueChange, value }) => {
    return (
        <ListItem>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    height: '64px'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                    }}
                >
                    <CheckBox
                        value={key}
                        checked={isActive}
                        onChange={(e) => {
                            onDisplayActiveChange(key, e.target.value.checked);
                        }}
                        data-testid={`display-tab-checkbox-${key}`}
                    />
                    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                        <span>If Discount is below or equal</span>
                        <NumericInput
                            disabled={!isActive}
                            sx={{ maxWidth: 120, caretColor: 'auto' }}
                            name={key}
                            displayLabel={false}
                            placeholder="Threshold"
                            inputPrefix={'$'}
                            value={value}
                            onChange={(e) => {
                                onDisplayValueChange(key, e.target.value || undefined);
                            }}
                        />
                        <span>do not show</span>
                    </Box>
                </Box>
            </Box>
        </ListItem>
    );
};

export default ConditionalDiscount;
